import { SegmentedControl } from "@mantine/core";
import i18n from "src/i18n";

import { languageValues } from "@data/dropdownValues";

import { StyledLanguageToggle } from "./LanguageToggle.styled";


export const LanguageToggle = () => {
  return (
    <StyledLanguageToggle>
      <SegmentedControl
        withItemsBorders={false}
        data={languageValues}
        value={i18n.language}
        onChange={val => {
          i18n.changeLanguage(val);
        }}
      />
    </StyledLanguageToggle>
  );
};
